<template>
  <div class="navigation-mobile" v-if="mobileNavigation">
    <div class="navigation-mobile__items">
      <div class="menu-tabs-item">
        <router-link :to="{name: 'building'}" exact class="menu-tabs-item--text" @click.native="toggleNav()">Building</router-link>
      </div>
      <div class="menu-tabs-item">
        <router-link :to="{name: 'residences'}" exact class="menu-tabs-item--text" @click.native="toggleNav()">Residences</router-link>
      </div>
      <div class="menu-tabs-item">
        <router-link :to="{name: 'penthouse'}" exact class="menu-tabs-item--text" @click.native="toggleNav()">Penthouse</router-link>
      </div>
      <div class="menu-tabs-item">
        <router-link :to="{name: 'neighborhood'}" exact class="menu-tabs-item--text" @click.native="toggleNav()">Neighborhood</router-link>
      </div>
      <div class="menu-tabs-item">
        <router-link :to="{name: 'map'}" exact class="menu-tabs-item--text" @click.native="toggleNav()">Map</router-link>
      </div>
      <div class="menu-tabs-item">
        <router-link :to="{name: 'availability'}" exact class="menu-tabs-item--text" @click.native="toggleNav()">Availability</router-link>
      </div>
      <div class="menu-tabs-item">
        <router-link :to="{name: 'team'}" exact class="menu-tabs-item--text" @click.native="toggleNav()">Team</router-link>
      </div>
      <div class="menu-tabs-item">
        <router-link :to="{name: 'contact'}" exact class="menu-tabs-item--text" @click.native="toggleNav()">Contact</router-link>
      </div>
      <div class="menu-tabs-item call">
        <a href="tel:347-713-7077" class="menu-tabs-item--text">Call</a>
      </div>
    </div>

    <a href="#" class="close" @click="toggleNav()"></a>
  </div>
</template>

<script>
    export default {
        name: "SidebarNavigation",
        props: {
          showMobileNavigation: {
            default: false,
            required: false,
          },
          toggleNavClass: {
            default: false,
            required: false
          }
        },
        data: () => ({
          mobileNavigation: false,
          screenWidth: null,
        }),
        watch: {
          showMobileNavigation: function(newVal) { // watch it
            this.mobileNavigation = newVal
          }

        },
        methods: {
          toggleNav() {
            this.mobileNavigation = !this.mobileNavigation;
            if(this.mobileNavigation) {
              document.documentElement.style.overflow = "hidden";
            } else {
              document.documentElement.style.overflow = "auto";
            }

            this.$emit('toggleNavClass', this.mobileNavigation)
          }
        }
    }
</script>

<style scoped>

</style>
